import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { AppointmentScheduleRequestModel } from '../business-entities/appointmentSchedule-request-model';
import { DealerHolidayViewModel } from '../business-entities/dealer-holiday-list-view-model';
import { DealerOpeningHoursViewModel } from '../business-entities/dealer-opening-hours-view-model';
import { SaveAppointmentPlanning } from '../business-entities/save-appointment-planning.model';
import { AppointmentPlanningDataService } from './../data-services/appointment-planning-data.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';


@Injectable({ providedIn: 'root' })
export class AppointmentPlanningService {
    dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
    dealerHolidays: DealerHolidayViewModel[] = [];
    isServicesAdded: boolean
    constructor(
        private appointmentPlanningDataService: AppointmentPlanningDataService,
        private datePipe: DatePipe,
    ) { }

    getAppointmentScheduleDetails(requestModel: AppointmentScheduleRequestModel): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getAppointmentScheduleDetails(requestModel);
    }
    getMechanicScheduleDetailsPlanningMenu(requestModel: AppointmentScheduleRequestModel): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getMechanicScheduleDetailsPlanningMenu(requestModel);
    }

    saveAppointmentPlanning(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.saveAppointmentPlanning(model);
    }
    saveSplitBooking(model: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.saveSplitBooking(model);
    }
    DeleteAppointmentPlanning(model: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.DeleteAppointmentPlanning(model);
    }

    UpdateAppointmentPlanningTime(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.UpdateAppointmentPlanningTime(model);
    }
    getMechanicMonthwiseHours(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getMechanicMonthwiseDetails(requestModel);
    }
    getWeekData(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getWeekData(requestModel);
    }
    getScheduleSummary(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getScheduleSummary(requestModel);
    }
    getMechanicInOutOverTime(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getMechanicInOutOverTime(requestModel);
    }
    getMechanicInOutSummary(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.getMechanicInOutSummary(requestModel);
    }
    GetWeekViewPlanning(requestModel: any): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.GetWeekViewPlanning(requestModel);
    }
    GetWOMechanicList(dealerId: string, dmsSyncRequired: boolean): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.GetWOMechanicList(dealerId, dmsSyncRequired);
    }
    GetMechanicJobListForWO(workOrderNo: string): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.GetMechanicJobListForWO(workOrderNo);
    }
    saveMechanicBlockedSlot(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.saveMechanicBlockedSlot(model);
    }
    DeleteBlockedMechanicSlot(slotId: number): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.DeleteBlockedMechanicSlot(slotId);
    }
    UpdateMechanicBlockedSlot(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.appointmentPlanningDataService.UpdateMechanicBlockedSlot(model);
    }
    /**
  * Purpose of the method to map shift details along with mechanics
  * @param mechanicId  - mechanic id
  * @param shiftsInfo  - all shift details
  * @cDate - current date
  */
    public CommonFilterMechanicShift(mechanicId: any, shiftsInfo: any, cDate: any): any {
        let supper = Object();
        let currentDate = this.datePipe.transform(new Date(cDate), 'yyy/MM/dd');
        if (shiftsInfo && shiftsInfo.length > 0) {
            let element = shiftsInfo.find(x => x.mechanicId === mechanicId);
            if (element) {
                supper.shiftTime = { start: `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.shiftStartTime))}`, end: `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.shiftEndTime))}` };
                let shiftStartDateTime = new Date(new Date(cDate).getFullYear() + '-' + (new Date(cDate).getMonth() + 1) + '-' + new Date(cDate).getDate() + ' ' + Utility.ConvertUTCDateToLocalTime(element.shiftStartTime));
                let shiftEndDateTime = new Date(new Date(cDate).getFullYear() + '-' + (new Date(cDate).getMonth() + 1) + '-' + new Date(cDate).getDate() + ' ' + Utility.ConvertUTCDateToLocalTime(element.shiftEndTime));

                // FOR NOT AVAILABLE
                let isNotAvailable = element.isNotAvailable, notAvailableStartTime = null, notAvailableEndTime = null;

                if (element.isNotAvailable) {
                    if (element.notAvailableStartDateTime && new Date(cDate).getDate() === Utility.ConvertUTCDateToLocalDate(element.notAvailableStartDateTime).getDate()) {
                        if (Utility.ConvertUTCDateToLocalDate(element.notAvailableStartDateTime) < shiftStartDateTime)
                            notAvailableStartTime = supper.shiftTime.start;
                        else
                            notAvailableStartTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.notAvailableStartDateTime))}`
                        if (element.notAvailableEndDateTime) {
                            if (Utility.ConvertUTCDateToLocalDate(element.notAvailableEndDateTime) > shiftEndDateTime)
                                notAvailableEndTime = supper.shiftTime.end;
                            else
                                notAvailableEndTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.notAvailableEndDateTime))}`
                        }
                        else {
                            notAvailableEndTime = supper.shiftTime.end;
                        }
                    }
                    else if (element.notAvailableStartDateTime && new Date(cDate).getTime() > Utility.ConvertUTCDateToLocalDate(element.notAvailableStartDateTime).getTime()) {
                        notAvailableStartTime = supper.shiftTime.start;
                        if (element.notAvailableEndDateTime) {
                            if (Utility.ConvertUTCDateToLocalDate(element.notAvailableEndDateTime) > shiftEndDateTime)
                                notAvailableEndTime = supper.shiftTime.end;
                            else
                                notAvailableEndTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.notAvailableEndDateTime))}`
                        }
                        else {
                            notAvailableEndTime = supper.shiftTime.end;
                        }
                    }

                    if (element.notAvailableEndDateTime && new Date(cDate).getTime() > Utility.ConvertUTCDateToLocalDate(element.notAvailableEndDateTime).getTime()) {
                        isNotAvailable = false;
                    }
                }

                let notAvailableData =
                {
                    isNotAvailable: isNotAvailable,
                    notAvailableStartTime: notAvailableStartTime,
                    notAvailableEndTime: notAvailableEndTime,
                    isIncludedLunchTime: true,
                    isIncludedBreak1Time: true,
                    isIncludedBreak2Time: true,
                    isIncludedLeaveTime: false
                }

                supper.notAvailableData = notAvailableData;

                // FOR LEAVE START AND END TIME
                let isOnLeave = element.isOnLeave, leaveStartTime = null, leaveEndTime = null;
                if (element.isOnLeave) {
                    if (element.leaveStartDateTime && element.leaveEndDateTime && new Date(cDate).getDate() === Utility.ConvertUTCDateToLocalDate(element.leaveStartDateTime).getDate()) {
                        //leave Start time
                        if (Utility.ConvertUTCDateToLocalDate(element.leaveStartDateTime) < shiftStartDateTime)
                            leaveStartTime = supper.shiftTime.start;
                        else
                            leaveStartTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.leaveStartDateTime))}`;
                        
                        //leave end time
                        if (Utility.ConvertUTCDateToLocalDate(element.leaveEndDateTime) > shiftEndDateTime)
                            leaveEndTime = supper.shiftTime.end;
                        else
                            leaveEndTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.leaveEndDateTime))}`;
                    }


                    else if (element.leaveStartDateTime && element.leaveEndDateTime && new Date(cDate).getTime() > Utility.ConvertUTCDateToLocalDate(element.leaveStartDateTime).getTime()) {
                        leaveStartTime = supper.shiftTime.start;
                        if (Utility.ConvertUTCDateToLocalDate(element.leaveEndDateTime) > shiftEndDateTime)
                            leaveEndTime = supper.shiftTime.end;
                        else
                            leaveEndTime = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.leaveEndDateTime))}`;
                    }
                }

                let leaveData =
                {
                    isOnLeave: isOnLeave,
                    leaveStartTime: leaveStartTime,
                    leaveEndTime: leaveEndTime,
                    isIncludedLunchTime: false,
                    isIncludedBreak1Time: false,
                    isIncludedBreak2Time: false,
                    isIncludedNotAvailable: false
                }

                supper.leaveData = leaveData;

                if (element.lunchStartTime != null && element.lunchEndTime != null) {
                    let lStart = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.lunchStartTime))}`;
                    let lEnd = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.lunchEndTime))}`;

                    let clSatrtDate = new Date(lStart);
                    let clEndDate = new Date(lEnd);
                    supper.lunchTime = { start: `${lStart}`, end: `${lEnd}`, calStart: this.datePipe.transform(clSatrtDate, 'yyyy/MM/dd HH:mm:ss'), calEnd: this.datePipe.transform(clEndDate, 'yyyy/MM/dd HH:mm:ss') };
                } else {
                    supper.lunchTime = { start: null, end: null, calStart: null, calEnd: null };
                }

                if (element.break1StartTime != null && element.break1EndTime != null) {
                    let b1Start = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.break1StartTime))}`;
                    let b1End = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.break1EndTime))}`;

                    let clSatrtDate = new Date(b1Start);
                    let clEndDate = new Date(b1End);
                    supper.break1Time = { start: `${b1Start}`, end: `${b1End}`, calStart: this.datePipe.transform(clSatrtDate, 'yyyy/MM/dd HH:mm:ss'), calEnd: this.datePipe.transform(clEndDate, 'yyyy/MM/dd HH:mm:ss') };
                } else {
                    supper.break1Time = { start: null, end: null, calStart: null, calEnd: null };
                }

                if (element.break2StartTime != null && element.break2EndTime != null) {
                    let b2Start = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.break2StartTime))}`;
                    let b2End = `${currentDate} ${this.calcuateEventTimeSlots(Utility.ConvertUTCDateToLocalTime(element.break2EndTime))}`;

                    let clSatrtDate = new Date(b2Start);
                    let clEndDate = new Date(b2End);
                    supper.break2Time = { start: `${b2Start}`, end: `${b2End}`, calStart: this.datePipe.transform(clSatrtDate, 'yyyy/MM/dd HH:mm:ss'), calEnd: this.datePipe.transform(clEndDate, 'yyyy/MM/dd HH:mm:ss') };
                } else {
                    supper.break2Time = { start: null, end: null, calStart: null, calEnd: null };
                }

                const lunchStart = new Date(supper.lunchTime.start);
                const lunchEnd = new Date(supper.lunchTime.end);

                const break1Start = new Date(supper.lunchTime.start);
                const break1End = new Date(supper.lunchTime.end);

                const break2Start = new Date(supper.lunchTime.start);
                const break2End = new Date(supper.lunchTime.end);
                if (supper.notAvailableData.isNotAvailable) {
                    const notAvStart = new Date(supper.notAvailableData.notAvailableStartTime);
                    const notAvEnd = new Date(supper.notAvailableData.notAvailableEndTime);
                    if (lunchStart >= notAvStart && lunchStart < notAvEnd && lunchEnd > notAvStart && lunchEnd <= notAvEnd) {
                        supper.notAvailableData.isIncludedLunchTime = true;
                    } else {
                        supper.notAvailableData.isIncludedLunchTime = false;
                    }
                    if (break1Start >= notAvStart && break1Start < notAvEnd && break1End > notAvStart && break1End <= notAvEnd) {
                        supper.notAvailableData.isIncludedBreak1Time = true;
                    } else {
                        supper.notAvailableData.isIncludedBreak1Time = false;
                    }
                    if (break2Start >= notAvStart && break2Start < notAvEnd && break2End > notAvStart && break2End <= notAvEnd) {
                        supper.notAvailableData.isIncludedBreak2Time = true;
                    } else {
                        supper.notAvailableData.isIncludedBreak2Time = false;
                    }
                    supper.notAvailableData.isIncludedLeaveTime = false;
                    if (supper.leaveData.isOnLeave) {
                        const leaveStart = new Date(supper.leaveData.leaveStartTime);
                        const leaveEnd = new Date(supper.leaveData.leaveEndTime);
                        if (leaveStart >= notAvStart && leaveStart < notAvEnd && leaveEnd > notAvStart && leaveEnd <= notAvEnd) {
                            supper.notAvailableData.isIncludedLeaveTime = true;
                        }
                    }
                }
                if (supper.leaveData.isOnLeave) {
                    const leaveStart = new Date(supper.leaveData.leaveStartTime);
                    const leaveEnd = new Date(supper.leaveData.leaveEndTime);
                    if (lunchStart >= leaveStart && lunchStart < leaveEnd && lunchEnd > leaveStart && lunchEnd <= leaveEnd) {
                        supper.leaveData.isIncludedLunchTime = true;
                    } else {
                        supper.leaveData.isIncludedLunchTime = false;
                    }
                    if (break1Start >= leaveStart && break1Start < leaveEnd && break1End > leaveStart && break1End <= leaveEnd) {
                        supper.leaveData.isIncludedBreak1Time = true;
                    } else {
                        supper.leaveData.isIncludedBreak1Time = false;
                    }
                    if (break2Start >= leaveStart && break2Start < leaveEnd && break2End > leaveStart && break2End <= leaveEnd) {
                        supper.leaveData.isIncludedBreak2Time = true;
                    } else {
                        supper.leaveData.isIncludedBreak2Time = false;
                    }
                    supper.leaveData.isIncludedNotAvailable = false;
                    if (supper.notAvailableData.isNotAvailable) {
                        const notAvStart = new Date(supper.notAvailableData.notAvailableStartTime);
                        const notAvEnd = new Date(supper.notAvailableData.notAvailableEndTime);
                        if (notAvStart >= leaveStart && notAvStart < leaveEnd && notAvEnd > leaveStart && notAvEnd <= leaveEnd) {
                            supper.leaveData.isIncludedNotAvailable = true;
                        }
                    }
                }
            }
            else { supper = null; }
        }
        else { supper = null; }
        return supper;
    }
    /**
   * Slot data re-mapper
   * @param eventTime
   */
    public calcuateEventTimeSlots(eventTime: any) {
        let result = eventTime
        let callTime = eventTime.split(':');

        if (Number.parseFloat(callTime[1]) > 0 && Number.parseFloat(callTime[1]) <= 15) {
            result = callTime[0] + ':15';
        }
        else if (Number.parseFloat(callTime[1]) > 15 && Number.parseFloat(callTime[1]) <= 30) {
            result = callTime[0] + ':30';
        }
        else if (Number.parseFloat(callTime[1]) > 30 && Number.parseFloat(callTime[1]) <= 45) {
            result = callTime[0] + ':45';
        }
        else if (Number.parseFloat(callTime[1]) > 45 && Number.parseFloat(callTime[1]) <= 60) {
            result = Number.parseFloat(callTime[0])+1 + ':00';
        }
        return result;

    }

    bookingErrorMessage(errorCode){
        let errorMessage = '';
        switch (errorCode) {
          case '1':
            errorMessage ="lblTimeSlotClashing";
            break;
          case '2':
            errorMessage ="lblDealerNotWorking";
            break;
          case '3':
            errorMessage ="lblHolidayDay";
            break;
          case '4':
            errorMessage ="lblMechanicLeave";
            break;
          case '5':
            errorMessage ="lblBookingClashWithLunch";
            break;
          case '6':
            errorMessage ="lblNoDealerShiftTime";
            break;
          default:
          errorMessage = fromEnums.ToastrMessages.NoMechanicAvailable;
            break;
        }
        return errorMessage;
      }
}